module.exports = __webpack_public_path__ + "static/media/6.78f2c777.jpg";